import pro1 from '../assets/Project1.png'
import pro2 from '../assets/Project2.png'
import pro3 from '../assets/Project3.jpeg'

// In this web app I have added a feature like search input where you have to enter a valid location or city name after then this information it will find the exact weather condition of this city.

const WorkingCardData = [
    {
        imagesrc:pro1,
        title:"Amazon Clone",
        text:"This is a Amazon Clone where I have try to implements some features like Authentications, adding Carts, removing Carts etc. It is now in progress mode In future I want add some new features like payment System, Order tracking System etc.",
        veiw:"https://clone-a9f37.web.app/",
        source:"https://github.com/universalDust123"
    },
    {
        imagesrc:pro3,
        title:"A Weather finder App",
        text:"It is weather Finder web app that fetch the data from third party Weather API(Application Programming Interface) in form of JSON format and then After the conversion in String format use it for UI/UX. ",
        source:"https://github.com/universalDust123/react-weather-finder"
    },
    {
        imagesrc:pro2,
        title:"UI/UX of a Coffee Shop",
        text:"This is a single page template of a coffee Shop. The Tech stack is used like HTML, CSS. This is a simple format example of UI/UX. Its have landing page, Content page and a footer.",
        source:"https://github.com/universalDust123/Coffe_shop_ui"
    }
]

export default WorkingCardData